import { lazy } from 'react';
import { FuseRouteItemType } from '@fuse/utils/FuseUtils';

const WordTilesPage = lazy(() => import('./NameAnalysisCreate'));
const path = 'reports/subword-frequency/create';
const WordTilesRoute: FuseRouteItemType = {
	path: path,
	element: <WordTilesPage />,
	settings: {
		layout: {
			config: {
				navbar: {
					display: true
				},
				toolbar: {
					title: 'Name Analysis for Create',
					showCrumbs: false,
					helpName: 'Name Analysis for Create'
				},
				footer: {
					display: false
				},
				leftSidePanel: {
					display: false
				},
				rightSidePanel: {
					display: false
				}
			}
		}
	}
};

export default WordTilesRoute;
